import { ref, onMounted, onUnmounted } from 'vue'

export function useScrollDirection() {
  const isHeaderVisible = ref(true)
  const lastScrollPosition = ref(0)
  const scrollThreshold = 50
  let scrollTimeout = null

  const handleScroll = () => {
    var body = document.querySelector("body");
    
    const currentScrollPosition = body.scrollTop 
        
    // Clear existing timeout
    if (scrollTimeout) {
      clearTimeout(scrollTimeout)
    }

    // Show header when user is near top
    if (currentScrollPosition < scrollThreshold) {
      isHeaderVisible.value = true
      return
    }

    // Determine scroll direction
    if (currentScrollPosition < lastScrollPosition.value) {
      // Scrolling up
      isHeaderVisible.value = true
    } else if (currentScrollPosition > lastScrollPosition.value) {
      // Scrolling down
      isHeaderVisible.value = false
    }

    // Set timeout to show header when scrolling stops
    scrollTimeout = setTimeout(() => {
      isHeaderVisible.value = true
    }, 1000)

    console.log(isHeaderVisible.value);
    
    lastScrollPosition.value = currentScrollPosition
  }

  onMounted(() => {
    var body = document.querySelector('body')
    body.addEventListener('scroll', handleScroll, { passive: true })
  })

  onUnmounted(() => {
    if (scrollTimeout) {
      clearTimeout(scrollTimeout)
    }
    var body = document.querySelector('body')
    body.removeEventListener('scroll', handleScroll)
  })

  return {
    isHeaderVisible
  }
}
